export default "<ngx-ui-loader></ngx-ui-loader>\r\n<router-outlet>\r\n\r\n</router-outlet>";